import { combineReducers, Reducer } from "redux";
import auditLog from "./auditLog/reducer";
import clientMetadata from "./clientMetadata/reducer";
import config from "./configState/reducer";
import briefSpread from "./documentList/reducer";
import documentUpload from "./documentUpload/reducer";
import entityList from "./entityList/reducer";
import entityView from "./entityView/reducer";
import user from "./login/reducer";
import metadata from "./metadata/reducer";
import pollingEnabled from "./polling/reducer";
import userPreferences from "./preferences/reducer";
import requestProgress from "./requestProgress/reducer";
import searchOptions from "./searchCache/reducer";
import session from "./session/reducer";
import alertBanner from "./shared/alertBanner/reducer";
import tag from "./spread/chartOfAccounts/Tag/reducer";
import isDebug from "./spread/model/debug/reducer";
import highlightedCells from "./spread/model/highlightedCells/reducer";
import highlightedRows from "./spread/model/highlightedRows/reducer";
import selectedCells from "./spread/model/selectedCells/reducer";
import spread from "./spread/model/spread/reducer";
import { State } from "./state";

const reducer: Reducer<State> = combineReducers({
  auditLog,
  alertBanner,
  briefSpread,
  documentUpload,
  highlightedCells,
  spread,
  requestProgress,
  selectedCells,
  isDebug,
  user,
  session,
  config,
  entityList,
  entityView,
  highlightedRows,
  metadata,
  tag,
  searchOptions,
  userPreferences,
  pollingEnabled,
  clientMetadata
});

export default reducer;



// WEBPACK FOOTER //
// ./src/reducer.ts